import { useQuery } from "@tanstack/react-query";
import fetchToBackend, { buildQuery } from "@/utils/fetchToBackend";
import { interestKeys } from "@/lib/query-keys";
import type { PriceItemCategory, UserInterest } from "@/types/domain";

export function useInterests(searchProfileId?: number) {
  return useQuery({
    queryKey: interestKeys.byProfile(searchProfileId),
    enabled: searchProfileId != null,
    queryFn: async () => {
      const query = buildQuery({ searchProfileId });
      const res = await fetchToBackend<any>(
        `/userpriceiteminterests/getAll${query}`,
      );
      return (res?.data ?? res ?? []) as UserInterest[];
    },
  });
}

export function useInterestCategories() {
  return useQuery({
    queryKey: interestKeys.categories,
    staleTime: 1000 * 60 * 60,
    queryFn: async () => {
      const res = await fetchToBackend<any>(
        "/userpriceiteminterests/categories",
      );
      return (res?.data ?? res ?? []) as PriceItemCategory[];
    },
  });
}
